module.exports = __webpack_public_path__ + "media/images/download-button-ba1b61e9423b657a60796b8afbb19a4a.svg";